import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const DealersView = lazy(() => import('../../container/crud/dealers/Index'));
const DealersAdd = lazy(() => import('../../container/crud/dealers/Add'));

const AxiosRoute = () => {
  // console.log("*****crud axios*****");
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}`} component={DealersView} />
      <Route path={`${path}/view`} component={DealersView} />
      <Route path={`${path}/add`} component={DealersAdd} />
      <Route exact path={`${path}/edit/:id`} component={DealersAdd} />
    </Switch>
  );
};

export default AxiosRoute;
